import {
  Button,
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap"
import React, { useEffect, useState } from "react"
import classnames from "classnames"
import {
  fetchData,
  FetchDeleteData,
  FetchPostData,
} from "utils/Common_api_functions"
import moment from "moment"
import { MdDelete, MdOutlineSubdirectoryArrowRight } from "react-icons/md"
import { FaPlus } from "react-icons/fa"
import Swal from "sweetalert2"

const NotesModal = ({ isopen, toggle, selectedStaff }) => {
  const [loading, setLoading] = useState(false)
  const [activeTab, setActiveTab] = useState("1")

  const [noteDate, setNoteDate] = useState("")
  const [noteText, setNoteText] = useState("")
  const [notes, setNotes] = useState([])

  useEffect(() => {
    if (selectedStaff) {
      fetchStaffNotes()
    }
  }, [selectedStaff])

  async function fetchStaffNotes() {
    const APIdata = await fetchData(
      setLoading,
      `employee/note/${selectedStaff}`
    )
    if (APIdata?.success) {
      setNotes(APIdata?.data || [])
    } else {
      Swal.fire({
        title: "Something Went Wrong",
        text: APIdata?.data?.message || APIdata?.response?.data?.message,
        icon: "error",
      })
    }
  }

  const handleAddNote = async () => {
    if (!noteDate || !noteText.trim() || !selectedStaff) return

    const APIdata = await FetchPostData(setLoading, "employee/note", {
      note: noteText,
      noteAddedAt: noteDate,
      employeeId: Number(selectedStaff),
    })
    if (APIdata?.data?.success) {
      Swal.fire({
        title: "Employee Note Added SuccessFully.",
        text: APIdata?.data?.message,
        icon: "success",
      })
      fetchStaffNotes()
      setActiveTab("2")
      setNoteDate("")
      setNoteText("")
    } else {
      Swal.fire({
        title: "Something Went Wrong",
        text: APIdata?.data?.message || APIdata?.response?.data?.message,
        icon: "error",
      })
    }
    // switch to previous notes after add
  }

  const handleDeleteNote = async id => {
    Swal.fire({
      title: "Delete this Note?",
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Delete",
    }).then(async result => {
      if (result.isConfirmed) {
        const APIdata = await FetchDeleteData(setLoading, "employee/note", id)
        if (APIdata?.data?.success) {
          Swal.fire({
            title: "Employee Note Deleted SuccessFully.",
            text: APIdata?.data?.message,
            icon: "success",
          })
          fetchStaffNotes()
          setActiveTab("2")
        } else {
          Swal.fire({
            title: "Something Went Wrong",
            text: APIdata?.data?.message || APIdata?.response?.data?.message,
            icon: "error",
          })
        }
      }
    })
    // switch to previous notes after add
  }

  return (
    <Modal isOpen={isopen} toggle={toggle} size="lg" centered>
      <ModalHeader toggle={toggle}>Staff Notes</ModalHeader>

      <ModalBody>
        {/* TABS */}
        <Nav tabs className="mb-3">
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === "1" })}
              onClick={() => setActiveTab("1")}
              style={{ cursor: "pointer" }}
            >
              ➕ Add Note
            </NavLink>
          </NavItem>

          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === "2" })}
              onClick={() => setActiveTab("2")}
              style={{ cursor: "pointer" }}
            >
              📝 Previous Notes
            </NavLink>
          </NavItem>
        </Nav>

        <TabContent activeTab={activeTab}>
          {/* ADD NOTE TAB */}
          <TabPane tabId="1">
            <Row className="mb-3 align-items-end">
              <Col md={6}>
                <label className="form-label">Date</label>
                <input
                  type="date"
                  className="form-control w-auto"
                  value={noteDate}
                  onChange={e => setNoteDate(e.target.value)}
                />
              </Col>
              <Col md={6} className="text-end">
                <Button
                  color="primary"
                  className="px-4 rounded-4"
                  onClick={handleAddNote}
                >
                  <FaPlus /> Add Note
                </Button>
              </Col>

              <Col md={12} className="mt-3">
                <label className="form-label">Note</label>
                <textarea
                  rows={3}
                  className="form-control"
                  placeholder="Enter note..."
                  value={noteText}
                  onChange={e => setNoteText(e.target.value)}
                />
              </Col>
            </Row>
          </TabPane>

          {/* PREVIOUS NOTES TAB */}
          <TabPane tabId="2">
            <div
              style={{
                maxHeight: "350px",
                overflowY: "auto",
              }}
            >
              {notes.length === 0 ? (
                <div className="text-center text-muted py-4">
                  No notes added yet
                </div>
              ) : (
                notes.map(item => (
                  <div
                    key={item.id}
                    className="d-flex bg-white p-3 mb-2 rounded-4 align-items-start justify-content-between"
                  >
                    <div className="d-flex gap-3">
                      <MdOutlineSubdirectoryArrowRight size={26} />
                      <div>
                        <h6 className="mb-1 text-muted">{item.noteAddedAt}, {moment(item?.createdAt)?.format("hh:mm A")}</h6>
                        <p className="mb-0 fw-semibold">{item.note}</p>
                      </div>
                    </div>
                    <Button
                      className="bg-danger"
                      onClick={() => handleDeleteNote(item?.id)}
                    >
                      <MdDelete size={20} />
                    </Button>
                  </div>
                ))
              )}
            </div>
          </TabPane>
        </TabContent>
      </ModalBody>
    </Modal>
  )
}

export default NotesModal
